import { includesPermission } from '../../utils/utils';
import { resolveDefaultResourceScope, resolveRbacPermission } from './permissionMapping';
import useResourcePermissions from './useResourcePermissions';
import useMyPermissions from '../../hooks/useMyPermissions';

export function usePermissionCheck({
  permission,
  rbacPermission,
  resourceType,
  resourceId,
  /** When true, check the flat union from getMyPermissions (any ACR scope). */
  anyScope = false,
  loadingValue = false
}) {
  const rbacPerm = rbacPermission ?? resolveRbacPermission(permission);
  const scope = resourceType ?? resolveDefaultResourceScope(permission).resourceType;
  const { permissions, loading } = useResourcePermissions({
    resourceType: scope,
    resourceId,
    skip: anyScope
  });
  const { permissions: myPermissions, isInitialLoading: myPermissionsLoading } = useMyPermissions({
    skip: !anyScope
  });

  if (anyScope) {
    if (myPermissionsLoading) {
      return { allowed: loadingValue, loading: true };
    }
    if (!rbacPerm) {
      return { allowed: false, loading: false };
    }
    return {
      allowed: includesPermission(myPermissions, rbacPerm),
      loading: false
    };
  }

  if (loading) {
    return { allowed: loadingValue, loading: true };
  }

  if (!rbacPerm) {
    return { allowed: false, loading: false };
  }

  return {
    allowed: includesPermission(permissions, rbacPerm),
    loading: false
  };
}

function useHasPermission({
  permission,
  rbacPermission,
  resourceType,
  resourceId,
  anyScope = false,
  loadingValue = false
}) {
  return usePermissionCheck({
    permission,
    rbacPermission,
    resourceType,
    resourceId,
    anyScope,
    loadingValue
  }).allowed;
}

export default useHasPermission;
